import React from 'react'
import { MobileMenuSection } from './mobile-menu-section'
import { StyledMenuItem, StyledSeparator } from './styled-menu-items'

type MobileFileSectionProps = {
  onClose?: () => void
  openPreferencesDialog: () => void
}

export const MobileFileSection: React.FC<MobileFileSectionProps> = ({
  onClose,
  openPreferencesDialog,
}) => {
  return (
    <MobileMenuSection value="file" label="File">
      <StyledMenuItem onClick={() => onClose?.()}>Close</StyledMenuItem>
      <StyledSeparator />
      <StyledMenuItem>Save Custom Template</StyledMenuItem>
      <StyledMenuItem>Make PDF</StyledMenuItem>
      <StyledSeparator />
      <StyledMenuItem>Review Restore Versions</StyledMenuItem>
      <StyledMenuItem>Revert to Blank Spread</StyledMenuItem>
      <StyledSeparator />
      <StyledMenuItem onClick={openPreferencesDialog}>Preferences</StyledMenuItem>
    </MobileMenuSection>
  )
}
